var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 802,
    viewBox: "0 0 1386 802",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10033_38377)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 802,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M40 732.234L99.7552 747.794C159.51 763.353 279.021 794.471 398.531 766.594C518.042 738.717 637.552 651.846 757.062 606.725C876.573 561.474 996.083 558.102 1115.59 580.922C1235.1 603.872 1354.61 653.142 1414.37 677.778L1474.12 702.413V852.817H1414.37C1354.61 852.817 1235.1 852.817 1115.59 852.817C996.083 852.817 876.573 852.817 757.062 852.817C637.552 852.817 518.042 852.817 398.531 852.817C279.021 852.817 159.51 852.817 99.7552 852.817H40V732.234Z",
    fill: "url(#paint0_linear_10033_38377)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-1354.24 710.521L-1290.93 726.339C-1227.63 741.566 -1101.02 774.088 -974.411 797.298C-847.802 821.394 -721.193 836.177 -594.584 797.298C-467.976 757.827 -479.772 631.58 -353.163 576.44C-226.554 520.708 -158.276 457.833 -31.6674 457.39C224.449 418.125 418.286 552.343 544.895 600.093C671.504 646.955 798.463 681.283 955.012 710.521C1093.57 726.339 1223.67 757.384 1350.28 710.521C1476.89 662.772 1557.77 632.172 1621.07 576.44L1684.37 521.299V899.744H1621.07C1557.77 899.744 1431.16 899.744 1304.55 899.744C1177.94 899.744 1051.33 899.744 924.722 899.744C798.113 899.744 671.504 899.744 544.895 899.744C418.286 899.744 291.677 899.744 165.069 899.744C38.4598 899.744 -88.1492 899.744 -214.758 899.744C-341.367 899.744 -467.976 899.744 -594.584 899.744C-721.193 899.744 -847.802 899.744 -974.411 899.744C-1101.02 899.744 -1227.63 899.744 -1290.93 899.744H-1354.24V710.521Z",
    fill: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 450.29L53.6433 456.073C107.287 461.856 182.164 476.096 253.688 518.569C355.946 565.611 459.88 650.078 589.518 672.869C686.746 708.352 858.293 730.815 965.58 694.643C1072.87 658.576 1334.38 805.395 1451.72 694.643C1559.01 715.042 1529.95 672.986 1585.27 650.078H1609.3V783.621H1555.66C1502.01 783.621 1394.73 783.621 1287.44 783.621C1180.15 783.621 1072.87 783.621 965.58 783.621C858.293 783.621 751.007 783.621 643.72 783.621C536.433 783.621 429.147 783.621 321.86 783.621C214.573 783.621 107.287 783.621 53.6433 783.621H0V450.29Z",
    fill: "url(#paint1_linear_10033_38377)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 669.858L50.9804 688.32C101.961 706.916 203.922 743.84 305.882 757.085C407.843 770.196 509.804 759.493 611.765 737.017C713.726 714.408 815.687 680.159 917.647 692.2C1019.61 704.241 1121.57 762.57 1223.53 762.57C1325.49 762.57 1427.45 704.24 1478.43 674.942L1529.41 645.777V837.088H1478.43C1427.45 837.088 1325.49 837.088 1223.53 837.088C1121.57 837.088 1019.61 837.088 917.647 837.088C815.687 837.088 713.726 837.088 611.765 837.088C509.804 837.088 407.843 837.088 305.882 837.088C203.922 837.088 101.961 837.088 50.9804 837.088H0V669.858Z",
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 582.285L33.0137 590.701C66.0275 598.801 131.863 616.103 198.275 641.034C264.014 666.437 330.137 699.469 395.587 712.288C462 724.636 528.412 716.771 593.862 699.705C659.986 682.953 725.725 657.786 792.137 645.203C857.972 632.619 924 632.619 990.412 636.788C1055.96 641.27 1122.28 649.135 1187.72 666.201C1254.04 682.953 1319.59 708.12 1353.28 720.704L1386 733.287V783.621H1352.99C1319.97 783.621 1254.14 783.621 1187.72 783.621C1121.99 783.621 1055.86 783.621 990.412 783.621C924 783.621 857.587 783.621 792.137 783.621C726.014 783.621 660.275 783.621 593.862 783.621C528.027 783.621 462 783.621 395.587 783.621C330.041 783.621 263.725 783.621 198.275 783.621C131.959 783.621 66.4125 783.621 32.725 783.621H0V582.285Z",
    fill: "url(#paint2_linear_10033_38377)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-78.925 707.271L-6.57713 728.796C65.7708 750.478 210.467 793.53 355.162 808.972C499.858 824.258 644.554 811.78 789.25 785.574C933.946 759.213 1078.64 719.282 1223.34 733.32C1368.03 747.359 1512.73 815.367 1657.42 815.367C1802.12 815.367 1946.82 747.359 2019.16 713.198L2091.51 679.194V902.25H2019.16C1946.82 902.25 1802.12 902.25 1657.42 902.25C1512.73 902.25 1368.03 902.25 1223.34 902.25C1078.64 902.25 933.946 902.25 789.25 902.25C644.554 902.25 499.858 902.25 355.162 902.25C210.467 902.25 65.7708 902.25 -6.57713 902.25H-78.925V707.271Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10033_38377",
    x1: 1073.5,
    y1: 688.993,
    x2: 1087.35,
    y2: 329.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10033_38377",
    x1: 804.65,
    y1: 450.29,
    x2: 804.65,
    y2: 783.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10033_38377",
    x1: 693,
    y1: 561.818,
    x2: 693,
    y2: 783.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10033_38377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 802,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.fa4eef546b07339972c85f5c8d817052.svg";
export { ForwardRef as ReactComponent };